/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import LabShutoffStatusBadge from '@/src/components/common/LabShutoffStatusBadge';
import SwitchToLegacyComponent from '@/src/components/switch-to-legacy-component/SwitchToLegacyComponent';
import { challengeAuthoringGuideUrl } from '@/src/utils/jam-urls';
import { Badge, Button, ButtonDropdown, ContentLayout, Icon, SpaceBetween } from '@amzn/awsui-components-react';
import { get } from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { Comment } from '../../../src/types/common';
import { CHALLENGE_DETAILS_ROUTES, challengeRoute, challengesRoute, resolve404Path } from '../../routes';
import { useApi } from '../../store/api.context';
import { useChallenges } from '../../store/challenge.context';
import { useCreateChallenge } from '../../store/create-challenge.context';
import { useUser } from '../../store/user.context';
import { ChallengeUtils, ChallengeWarningResponse, MarkChallengeDefectiveRequest } from '../../types/Challenge';
import { getErrorMessage, getJamClient } from '@/src/api/sdk/JamClient';
import { useAuth } from '@/src/store/auth.context';
import { useFlashbars } from '@/src/store/flashbar.context';
import { ArenaDefinitionUpdate, isArenaChallenge } from '../../utils/arena.utils';
import { i18nKeys } from '../../utils/i18n.utils';
import { preProdLogger } from '../../utils/log.utils';
import Comments from '../common/Comments/Comments';
import { ConfirmModal } from '../common/ConfirmModal';
import JamSpinner from '../common/JamSpinner/JamSpinner';
import { PageHeader } from '../common/PageHeader';
import ArenaDimensions from './challengeDetailSections/challengeArena/ArenaDimensions';
import ArenaRequirements from './challengeDetailSections/challengeArena/ArenaRequirements';
import ArenaScenario from './challengeDetailSections/challengeArena/ArenaScenario';
import ChallengeCFNTemplateDetail from './challengeDetailSections/challengeCFNTemplate/CFNTemplate';
import ChallengeCollaboratorsDetail from './challengeDetailSections/challengeCollaborators/Collaborators';
import ChallengeFacilitatorNotesDetail from './challengeDetailSections/challengeFacilitatorNotes/FacilitatorNotes';
import ChallengeFeedbackDetails from './challengeDetailSections/challengeFeedback/ChallengeFeedbackDetails';
import ChallengeHelpDetail from './challengeDetailSections/challengeHelp/Help';
import ChallengeIAMPolicyDetail from './challengeDetailSections/challengeIAMPolicy/IAMPolicy';
import ChallengeIssuesDetail from './challengeDetailSections/challengeIssues/Issues';
import ChallengeIssuesDetailSingle from './challengeDetailSections/challengeIssues/SingleIssue';
import LearningOutcomeDetail from './challengeDetailSections/challengeLearningOutcome/LearningOutcome';
import ChallengeNextStepsDetail from './challengeDetailSections/challengeNextSteps/NextSteps';
import ChallengeResourcesDetail from './challengeDetailSections/challengeResources/Resources';
import ReviewButtonPanel from './challengeDetailSections/challengeReviewCommon/ReviewButtonPanel';
import ReviewProgressTracker from './challengeDetailSections/challengeReviewCommon/ReviewProgressTracker';
import ChallengeRevisionsDetail from './challengeDetailSections/challengeRevisions/Revisions';
import ChallengeSettingsDetails from './challengeDetailSections/challengeSettings/ChallengeSettingsDetails';
import ChallengeStatsDetails from './challengeDetailSections/challengeStats/ChallengeStatsDetails';
import ChallengeSummaryDetails from './challengeDetailSections/challengeSummary/ChallengeSummaryDetails';
import ChallengeOverviewDetail from './challengeDetailSections/challengeSummary/Overview';
import ChallengeTasksDetail from './challengeDetailSections/challengeTask/Tasks';
import ChallengeTestingDetail from './challengeDetailSections/challengeTesting/Testing';
import ChallengeTranslationDetails from './challengeDetailSections/challengeTranslation/ChallengeTranslationDetails';
import ChallengeWikiDetail from './challengeDetailSections/challengeWiki/Wiki';
import { isRouteMatch } from '@/src/utils/hybrid-console/utils';
import { LabShutoffCandidate, LabShutoffStatus } from '@/src/types/LabShutoff';

const ChallengeDetails: React.FC<{ shutoffRequestDelay?: number }> = ({ shutoffRequestDelay = 1000 }) => {
  const { t } = useTranslation();
  const { challengeId }: { challengeId: string } = useParams();
  const history = useHistory();
  const { user } = useUser();
  const { challengesApi, labshutoffAPI } = useApi();
  const {
    challenge,
    getChallenge,
    updatePublicStatus,
    updateDemoStatus,
    archiveChallenge,
    unarchiveChallenge,
    addChallengeComment,
    updateChallengeComment,
    deleteChallengeComment,
    deleteChallenge,
  } = useChallenges();
  const { editMode, toggleChallengeEditMode, exitChallengeEditMode, initializeNewChallenge, saveEditedChallenge } =
    useCreateChallenge();

  const { authClient } = useAuth();
  const jamClient = getJamClient(authClient);
  const { addErrorFlashbar } = useFlashbars();

  const { pathname } = useLocation();

  const [loading, setLoading] = useState(true);

  // Modal Visibility Settings
  const [confirmDefectiveVisible, setConfirmDefectiveVisible] = useState(false);
  const [confirmShutoffVisible, setConfirmShutoffVisible] = useState(false);
  const [confirmTurnOnVisible, setConfirmTurnOnVisible] = useState(false);
  const [confirmArchiveVisible, setConfirmArchiveVisible] = useState(false);
  const [confirmPrivateVisble, setConfirmPrivateVisible] = useState(false);
  const [confirmDemoVisible, setConfirmDemoVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

  // Modal Messages
  const [defectiveMessage, setDefectiveMessage] = useState('');
  const [defectiveYesLabel, setDefectiveYesLabel] = useState('');
  const [defectiveWarningToken, setDefectiveWarningToken] = useState('');

  const [privateMessage, setPrivateMessage] = useState('');
  const [privateYesLabel, setPrivateYesLabel] = useState('');

  const [demoMessage, setDemoMessage] = useState('');
  const [demoYesLabel, setDemoYesLAbel] = useState('');

  const [archiveMessage, setArchiveMessage] = useState('');
  const [archiveYesLabel, setArchiveYesLabel] = useState('');
  const [deleteMessage, setDeleteMessage] = useState('');
  const [deleteYesLabel, setDeleteYesLabel] = useState('');

  const [shutoffReason, setShutoffReason] = useState('');

  const [submittingDefective, setSubmittingDefective] = useState(false);
  const [optionalDefectiveReason, setOptionalDefectiveReason] = useState('');

  const [shutoffStatus, setShutoffStatus] = useState<LabShutoffStatus | undefined>();

  const displayOverviewChallenges = [CHALLENGE_DETAILS_ROUTES.Tasks.wildcard().split('/')[3]];

  const comments: Comment[] = challenge?.props.comments ? challenge.props.comments : [];

  const generateShutoffCandidate = useCallback(
    () => Object.assign(new LabShutoffCandidate(), { challengeId }),
    [challengeId]
  );

  const loadLabShutoffStatus = useCallback(() => {
    if (user?.isSuperAdmin) {
      return labshutoffAPI.getShutoffStatuses([generateShutoffCandidate()], !user.isSuperAdmin).then((response) => {
        const relevantStatus = response.statuses[generateShutoffCandidate().toCandidateString() || ''];
        setShutoffStatus(relevantStatus);
      });
    }
  }, [challengeId]);

  useEffect(() => {
    loadChallenge();
    loadLabShutoffStatus();
  }, [challengeId]);

  const challengeSingleIssueMatch = useRouteMatch(CHALLENGE_DETAILS_ROUTES.IssuesSingle.wildcard());

  /*
   * Which section is in view, derived synchronously from the router's pathname.
   *
   * Derived rather than held in state on purpose: state assigned from an effect
   * lags one render behind pathname, so anything reading these flags during that
   * render would evaluate against the section the user just left.
   *
   * The router's pathname is used rather than the global window.location. The two
   * agree under BrowserRouter, but only the router's value is guaranteed to match
   * the section actually rendered.
   */
  const resourcesRoute = useMemo(
    () => isRouteMatch(CHALLENGE_DETAILS_ROUTES.Assets.replaceTokens([challengeId]), pathname),
    [challengeId, pathname]
  );

  const translationRoute = useMemo(
    () => isRouteMatch(CHALLENGE_DETAILS_ROUTES.Translation.replaceTokens([challengeId]), pathname),
    [challengeId, pathname]
  );

  const issueRoute = useMemo(
    () =>
      isRouteMatch(CHALLENGE_DETAILS_ROUTES.Issues.replaceTokens([challengeId]), pathname) ||
      isRouteMatch(
        CHALLENGE_DETAILS_ROUTES.IssuesSingle.replaceTokens([
          challengeId,
          get(challengeSingleIssueMatch, 'params.1', ''),
        ]),
        pathname
      ),
    [challengeId, pathname, challengeSingleIssueMatch]
  );

  const arenaRoute = useMemo(
    () =>
      isRouteMatch(CHALLENGE_DETAILS_ROUTES.ArenaScenario.replaceTokens([challengeId]), pathname) ||
      isRouteMatch(CHALLENGE_DETAILS_ROUTES.ArenaRequirements.replaceTokens([challengeId]), pathname) ||
      isRouteMatch(CHALLENGE_DETAILS_ROUTES.ArenaDimensions.replaceTokens([challengeId]), pathname),
    [challengeId, pathname]
  );

  /**
   * Whether the shared edit/save controls apply to the section currently in view.
   *
   * Single source of truth for the permission-to-edit rule. Both the save
   * controls and the exit-edit-mode effect below read this, so they cannot
   * disagree about which section is in view or which predicate applies to it.
   */
  const showEditButtons = useMemo(() => {
    if (resourcesRoute || arenaRoute) {
      // Assets and Arena sections manage their own editing; the shared edit/save controls never show here.
      return false;
    }
    if (translationRoute) {
      return ChallengeUtils.canEditTranslations(challenge, user);
    }
    return ChallengeUtils.isCollaborator(challenge, user);
  }, [resourcesRoute, arenaRoute, translationRoute, challenge, user]);

  // Edit mode lives in the app-level CreateChallengeProvider, so it outlives any
  // single section. Drop it when navigating to a section this user cannot edit,
  // otherwise that section would render its editable controls. Edit mode is
  // preserved when moving between sections the user can edit, so an in-progress
  // edit survives navigation.
  //
  // This matters most for Translation, which turns edit mode on by itself when a
  // language is picked: a translator-only user leaving that page must not carry
  // edit mode into sections that require challenge-builder.
  //
  // Keyed on pathname alone by design. Re-running when challenge or user change
  // would exit edit mode mid-edit every time the challenge is refetched.
  useEffect(() => {
    if (!showEditButtons) {
      exitChallengeEditMode();
    }
  }, [pathname]);

  // Leaving challenge details entirely means there is no challenge section to be
  // editing, so clear the flag rather than leaving it set for the next consumer.
  useEffect(() => {
    return () => exitChallengeEditMode();
  }, []);

  const handleSaveArenaDefinition = async (update: ArenaDefinitionUpdate): Promise<boolean> => {
    const res = await jamClient.updateArenaDefinition({
      ...update,
      challengeId,
      lastKnownVersion: challenge?.version ?? undefined,
    });

    if (res instanceof Error) {
      addErrorFlashbar(getErrorMessage(res));
      return false;
    }

    await getChallenge(challengeId).catch((err) => preProdLogger('Error reloading challenge', err));
    return true;
  };

  const loadChallenge = () => {
    setLoading(true);
    getChallenge(challengeId)
      .catch((err) => preProdLogger('Error loading challenge', err))
      .finally(() => setLoading(false));
  };

  if (!loading && history && challenge == null) {
    history.push(resolve404Path(challengeRoute.resolvePath(challengeId)));
    return null;
  }

  // const comments: Comment[] = challenge?.props.comments ? challenge.props.comments : [];

  // Currently we are hiding the components because currently have to redirect these component into v1 but later on we will use these components
  const canEditArena = !challenge?.isArchived && ChallengeUtils.isCollaborator(challenge, user);

  const renderChildView = () => {
    return challenge ? (
      <Switch>
        <Route path={CHALLENGE_DETAILS_ROUTES.LearningOutcome.wildcard()}>
          <LearningOutcomeDetail challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.Settings.wildcard()}>
          <ChallengeSettingsDetails challenge={challenge} />
        </Route>
        {isArenaChallenge(challenge) && (
          <Route path={CHALLENGE_DETAILS_ROUTES.ArenaScenario.wildcard()}>
            <ArenaScenario
              arenaDefinition={challenge.props.arenaDefinition}
              canEdit={canEditArena}
              onSave={handleSaveArenaDefinition}
            />
          </Route>
        )}
        {isArenaChallenge(challenge) && (
          <Route path={CHALLENGE_DETAILS_ROUTES.ArenaRequirements.wildcard()}>
            <ArenaRequirements
              arenaDefinition={challenge.props.arenaDefinition}
              canEdit={canEditArena}
              onSave={handleSaveArenaDefinition}
            />
          </Route>
        )}
        {isArenaChallenge(challenge) && (
          <Route path={CHALLENGE_DETAILS_ROUTES.ArenaDimensions.wildcard()}>
            <ArenaDimensions
              arenaDefinition={challenge.props.arenaDefinition}
              canEdit={canEditArena}
              onSave={handleSaveArenaDefinition}
            />
          </Route>
        )}
        {!isArenaChallenge(challenge) && (
          <Route path={CHALLENGE_DETAILS_ROUTES.Tasks.wildcard()}>
            <ChallengeTasksDetail challenge={challenge} />
          </Route>
        )}
        <Route path={CHALLENGE_DETAILS_ROUTES.Assets.wildcard()}>
          <ChallengeResourcesDetail challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.IamPolicy.wildcard()}>
          <ChallengeIAMPolicyDetail challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.CfnTemplate.wildcard()}>
          <ChallengeCFNTemplateDetail challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.NextSteps.wildcard()}>
          <ChallengeNextStepsDetail challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.Wiki.wildcard()}>
          <ChallengeWikiDetail challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.Collaborators.wildcard()}>
          <ChallengeCollaboratorsDetail challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.Issues.wildcard()} exact>
          <ChallengeIssuesDetail challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.IssuesSingle.wildcard()}>
          <ChallengeIssuesDetailSingle challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.Comments.wildcard()}>
          <Comments
            comments={comments || []}
            addNewComment={addChallengeComment}
            deleteComment={deleteChallengeComment}
            updateComment={updateChallengeComment}
            data-testid="challenge-comments"
          />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.Testing.wildcard()}>
          <ChallengeTestingDetail challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.Feedback.wildcard()}>
          <ChallengeFeedbackDetails challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.Stats.wildcard()}>
          <ChallengeStatsDetails challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.Revisions.wildcard()}>
          <ChallengeRevisionsDetail />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.Reviews.wildcard()}>
          {/* <ChallengeReviewDetail /> */}
          {SwitchToLegacyComponent}
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.Translation.wildcard()}>
          <ChallengeTranslationDetails challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.FacilitatorNotes.wildcard()}>
          <ChallengeFacilitatorNotesDetail challenge={challenge} />
        </Route>
        <Route path={CHALLENGE_DETAILS_ROUTES.Help.wildcard()}>
          <ChallengeHelpDetail />
        </Route>
        {/* Summary must be last */}
        <Route path={CHALLENGE_DETAILS_ROUTES.Summary.wildcard()}>
          <ChallengeSummaryDetails challenge={challenge} />
        </Route>
      </Switch>
    ) : null;
  };

  // Whether to render the save controls for the section currently in view. Shares
  // showEditButtons with the exit-edit-mode effect so the two can never
  // disagree about who may edit what.
  const showSaveControls = editMode && showEditButtons;

  const shouldShowButton = (buttonName: string): boolean => {
    if (editMode) {
      return false;
    }

    if (user && challenge) {
      switch (buttonName) {
        case 'critical-issue':
          // return this.challengeGlobalStats.highestIssueSeverity === ChallengeIssueSeverity.CRITICAL;
          break;
        case 'clone':
          return false;
        case 'delete':
          return user.isSuperAdmin;
        case 'archive':
          return ChallengeUtils.isChallengeAdmin(user);
        case 'defective':
          return ChallengeUtils.isChallengeAdmin(user);
        case 'public':
          return ChallengeUtils.isChallengeAdmin(user);
        case 'demo':
          return ChallengeUtils.isChallengeAdmin(user);
        default:
          return false;
      }
    }

    return false;
  };

  const handleActionClick = (clickEvent: any) => {
    switch (clickEvent.detail.id) {
      case 'defective':
        void setDefectiveMessages();
        setConfirmDefectiveVisible(true);
        break;
      case 'shutOffLabDeployment':
        setConfirmShutoffVisible(true);
        break;
      case 'turnOnLabDeployment':
        setConfirmTurnOnVisible(true);
        break;
      case 'public':
        setPrivateMessages();
        setConfirmPrivateVisible(true);
        break;
      case 'demo':
        setDemoMessages();
        setConfirmDemoVisible(true);
        break;
      case 'archive':
        setArchiveMessages();
        setConfirmArchiveVisible(true);
        break;
      case 'delete':
        setDeleteMessages();
        setConfirmDeleteVisible(true);
        break;
    }
    return;
  };

  const setDefectiveMessages = async () => {
    setSubmittingDefective(true);
    try {
      const newDefectiveState = !challenge?.isDefective;
      let message = '';

      if (!newDefectiveState) {
        message = t(i18nKeys.challenges.challengeDetails.messages.removeDefectiveState);
        setDefectiveYesLabel(t(i18nKeys.challenges.challengeDetails.yesLabels.removeDefectiveState));
      } else {
        message = t(i18nKeys.challenges.challengeDetails.messages.markDefectiveState);
        setDefectiveYesLabel(t(i18nKeys.challenges.challengeDetails.yesLabels.markDefectiveState));
      }

      let warningToken = '';

      // i.e. if this challenge is transitioning from not defective to defective
      if (newDefectiveState === true && !challenge?.isDefective) {
        /* Get a list of warnings and a token associated with marking this challenge as defective. */
        const warning: ChallengeWarningResponse = await challengesApi.getMarkDefectiveWarnings(challengeId, false);

        warningToken = warning.warningToken;

        if (warning.warnings !== undefined && warning.warnings.length > 0) {
          message += '\n\nWarning: ';

          for (const warningMessage of warning.warnings) {
            message += `${warningMessage}\n`;
          }
        }
        setDefectiveWarningToken(warningToken);
        setDefectiveMessage(message);
      }
    } finally {
      setSubmittingDefective(false);
    }
  };

  const handleDefectiveConfirmation = async () => {
    const request: MarkChallengeDefectiveRequest = {
      challengeId,
      defective: !challenge?.isDefective,
      warningToken: defectiveWarningToken,
      optionalComment: optionalDefectiveReason,
    };
    setSubmittingDefective(true);
    try {
      await challengesApi.updateDefectiveStatus(challengeId, request);
      setConfirmDefectiveVisible(false);
    } finally {
      setSubmittingDefective(false);
    }
  };

  const handleShutOffConfirmation = async () => {
    setLoading(true);
    try {
      await labshutoffAPI.shutoffCandidate(shutoffReason, generateShutoffCandidate());
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('error during challenge lab shutoff', err);
    } finally {
      setTimeout(loadLabShutoffStatus, shutoffRequestDelay);
      setLoading(false);
      setConfirmShutoffVisible(false);
    }
  };

  const isVisibleOverview = () => {
    const paths = pathname.split('/');
    const pageName = paths[paths.length - 1];
    return displayOverviewChallenges.includes(pageName);
  };

  const setPrivateMessages = () => {
    if (!challenge?.isPublic) {
      setPrivateMessage(t(i18nKeys.challenges.challengeDetails.messages.markChallengePublic));
      setPrivateYesLabel(t(i18nKeys.challenges.challengeDetails.yesLabels.markChallengePublic));
    } else {
      setPrivateMessage(t(i18nKeys.challenges.challengeDetails.messages.markChallengePrivate));
      setPrivateYesLabel(t(i18nKeys.challenges.challengeDetails.yesLabels.markChallengePrivate));
    }
  };

  const handlePrivateConfirmation = () => {
    void updatePublicStatus(challengeId, !challenge?.isPublic);
    setConfirmPrivateVisible(false);
  };

  const setDemoMessages = () => {
    const newDemoState = !challenge?.isDemo;

    let newDemoMessage = '';

    if (!newDemoState) {
      newDemoMessage = t(i18nKeys.challenges.challengeDetails.messages.removeAsExampleChallenge);
      setDemoYesLAbel(t(i18nKeys.challenges.challengeDetails.yesLabels.removeAsExampleChallenge));
    } else {
      newDemoMessage = t(i18nKeys.challenges.challengeDetails.messages.markAsExampleChallenge);
      if (!challenge?.isPublic) {
        newDemoMessage += t(i18nKeys.challenges.challengeDetails.messages.markAsNewExampleChallenge);
      }
      setDefectiveYesLabel(t(i18nKeys.challenges.challengeDetails.yesLabels.markAsExampleChallenge));
    }

    setDemoMessage(newDemoMessage);
  };

  const handleDemoConfirmation = () => {
    void updateDemoStatus(challengeId, !challenge?.isDemo);
    setConfirmDemoVisible(false);
  };

  const setArchiveMessages = () => {
    if (challenge?.isArchived) {
      setArchiveMessage(t(i18nKeys.challenges.challengeDetails.messages.unarchiveChallenge));
      setArchiveYesLabel(t(i18nKeys.challenges.challengeDetails.yesLabels.unarchiveChallenge));
    } else {
      setArchiveMessage(t(i18nKeys.challenges.challengeDetails.messages.archiveChallenge));
      setArchiveYesLabel(t(i18nKeys.challenges.challengeDetails.yesLabels.archiveChallenge));
    }
  };

  const handleArchiveConfirmation = () => {
    if (challenge?.isArchived) {
      void unarchiveChallenge(challengeId);
    } else {
      void archiveChallenge(challengeId);
    }
    setConfirmArchiveVisible(false);
  };

  const handleToggleEdit = () => {
    if (challenge) {
      initializeNewChallenge();
    }

    toggleChallengeEditMode(challenge || null);
  };

  const handleDeleteChallenge = () => {
    void deleteChallenge(challengeId);
    setConfirmDeleteVisible(false);
    if (history) {
      history.push(challengesRoute.path);
    }
  };

  const setDeleteMessages = () => {
    setDeleteMessage(t(i18nKeys.challenges.challengeDetails.messages.deleteChallenge));
    setDeleteYesLabel(t(i18nKeys.challenges.challengeDetails.yesLabels.delete));
  };

  const handleSaveChallenge = () => {
    setLoading(true);
    saveEditedChallenge()
      .then((c) => {
        if (c) {
          getChallenge(c.challengeId || '')
            .then(() => {
              // The translation section has no Edit button of its own -- it enters
              // edit mode automatically when a language is picked. Leaving edit
              // mode here would hide the save controls with no way to bring them
              // back, so translators could only ever save once.
              if (!translationRoute) {
                exitChallengeEditMode();
              }
            })
            .catch((err) => preProdLogger(err));
        }
      })
      .catch((err) => preProdLogger(err))
      .finally(() => setLoading(false));
  };

  const badges = useMemo(() => {
    const badgeMap =
      challenge?.badges.map((badge, key) => (
        <span key={key}>
          <Badge color={badge?.color}>{badge?.text ? t(badge.text) : ''}</Badge>
        </span>
      )) || [];
    badgeMap.push(
      <span key="shutoff-status">
        <LabShutoffStatusBadge shutoffStatus={shutoffStatus} />
      </span>
    );
    if (challenge?.isArchived) {
      badgeMap.unshift(
        <Badge color="grey">
          <Icon name="status-stopped" />{' '}
          <span style={{ textTransform: 'uppercase' }}>{t(i18nKeys.general.archived)}</span>
        </Badge>
      );
    }
    return badgeMap;
  }, [challenge]);

  return (
    <>
      {loading && <JamSpinner />}
      <ReviewProgressTracker />
      <ContentLayout
        header={
          <PageHeader
            title={challenge?.props.title || 'Untitled Challenge'}
            badges={badges}
            buttons={[
              // eslint-disable-next-line
              <SpaceBetween size="xxs" direction="horizontal">
                {
                  <Button className="mr-5" href={challengeAuthoringGuideUrl}>
                    {t(i18nKeys.home.gettingStarted.links.challengeAuthoringGuide)}
                  </Button>
                }
                <ReviewButtonPanel />
                <span key="challenge-details-button">
                  {shouldShowButton('public') && (
                    <ButtonDropdown
                      data-testid="challenge-details__button-dropdown"
                      className="mr-5"
                      onItemClick={handleActionClick}
                      items={[
                        // Non-null assertions necessary due to i18nKeys being string | undefined and ItemOrGroup requiring text to be just string
                        // i18nKey should never be undefined
                        {
                          text:
                            (challenge?.isDefective
                              ? t(i18nKeys.challenges.challengeDetails.buttons.removeChallengeDefective)
                              : t(i18nKeys.challenges.challengeDetails.buttons.markChallengeDefective)) || '',
                          id: 'defective',
                          disabled: !shouldShowButton('defective'),
                        },
                        {
                          text:
                            (shutoffStatus?.selfShutoff
                              ? t(i18nKeys.challenges.challengeDetails.buttons.turnOnLabDeployment)
                              : t(i18nKeys.challenges.challengeDetails.buttons.shutOffLabDeployment)) || '',
                          id: shutoffStatus?.selfShutoff ? 'turnOnLabDeployment' : 'shutOffLabDeployment',
                          disabled: false,
                        },
                        {
                          text:
                            (challenge?.isPrivate
                              ? t(i18nKeys.challenges.challengeDetails.buttons.markChallengePublic)
                              : t(i18nKeys.challenges.challengeDetails.buttons.markChallengePrivate)) || '',
                          id: 'public',
                          disabled: !shouldShowButton('public'),
                        },
                        {
                          text:
                            (challenge?.isDemo
                              ? t(i18nKeys.challenges.challengeDetails.buttons.removeAsExampleChallenge)
                              : t(i18nKeys.challenges.challengeDetails.buttons.markAsExampleChallenge)) || '',
                          id: 'demo',
                          disabled: !shouldShowButton('demo'),
                        },
                        {
                          text:
                            (challenge?.isArchived
                              ? t(i18nKeys.challenges.challengeDetails.buttons.unarchiveChallenge)
                              : t(i18nKeys.challenges.challengeDetails.buttons.archiveChallenge)) || '',
                          id: 'archive',
                          disabled: !shouldShowButton('archive'),
                        },
                        {
                          text: t(i18nKeys.challenges.challengeDetails.buttons.deleteChallenge) || '',
                          id: 'delete',
                          disabled: !shouldShowButton('delete'),
                        },
                      ]}
                    >
                      {t(i18nKeys.events.eventDetails.buttons.actionsPlaceholder)}
                    </ButtonDropdown>
                  )}
                  {!challenge?.isArchived &&
                    !editMode &&
                    !issueRoute &&
                    !resourcesRoute &&
                    !arenaRoute &&
                    !translationRoute &&
                    ChallengeUtils.isCollaborator(challenge, user) && (
                      <Button
                        className="mr-5"
                        onClick={() => handleToggleEdit()}
                        loading={loading}
                        data-testid="challenge-edit-button"
                      >
                        {t(i18nKeys.general.edit)}
                      </Button>
                    )}
                  {/*
                    Cancel means "go back to viewing", which only makes sense where
                    an Edit button exists to re-enter. The translation section has
                    none, so cancelling there would leave the user stuck in a view
                    with editable fields and no way to save.
                  */}
                  {showSaveControls && !translationRoute && (
                    <Button
                      className="mr-5"
                      variant="link"
                      onClick={() => toggleChallengeEditMode(challenge || null)}
                      disabled={loading}
                      data-testid="challenge-cancel-button"
                    >
                      {t(i18nKeys.general.cancel)}
                    </Button>
                  )}
                  {showSaveControls && (
                    <Button
                      className="mr-5"
                      variant="primary"
                      onClick={handleSaveChallenge}
                      disabled={loading}
                      data-testid="challenge-save-button"
                    >
                      {t(i18nKeys.general.save)}
                    </Button>
                  )}
                </span>
              </SpaceBetween>,
            ]}
          />
        }
      >
        <ConfirmModal
          message={defectiveMessage}
          visible={confirmDefectiveVisible}
          confirmBtnLabel={defectiveYesLabel}
          textInput={optionalDefectiveReason}
          onTextInput={setOptionalDefectiveReason}
          disabled={submittingDefective}
          loading={submittingDefective}
          onConfirm={handleDefectiveConfirmation}
          onCancel={() => setConfirmDefectiveVisible(false)}
          data-testid="challenge-details__confirm-defective-modal"
        />
        <ConfirmModal
          visible={confirmShutoffVisible}
          title={t(i18nKeys.labDashboard.shutoffs.modal.areYouSureShutOff, { str: challengeId })}
          message={t(i18nKeys.myJams.challenges.restart.prompt.restartChallenge.title)}
          confirmBtnLabel={t(i18nKeys.general.confirm)}
          onConfirm={handleShutOffConfirmation}
          onCancel={() => setConfirmShutoffVisible(false)}
          data-testid="challenge-details__confirm-shutoff-modal"
          submitButtonId="challenge-details__confirm-shutoff-btn"
          textInput={shutoffReason}
          onTextInput={setShutoffReason}
          disabled={!shutoffReason}
        />
        <ConfirmModal
          visible={confirmTurnOnVisible}
          title={t(i18nKeys.labDashboard.shutoffs.modal.areYouSureTurnOn, { str: challengeId })}
          confirmBtnLabel={t(i18nKeys.general.confirm)}
          data-testid="challenge-details__confirm-turnon-modal"
          submitButtonId="challenge-details__confirm-turnon-btn"
          onConfirm={async () => {
            setLoading(true);
            try {
              await labshutoffAPI.turnOnCandidate(generateShutoffCandidate());
            } catch (err) {
              // eslint-disable-next-line no-console
              console.error('Error turning on lab deployment', err);
            } finally {
              setTimeout(loadLabShutoffStatus, shutoffRequestDelay);
              setLoading(false);
              setConfirmTurnOnVisible(false);
            }
          }}
          onCancel={() => setConfirmTurnOnVisible(false)}
        />
        <ConfirmModal
          message={privateMessage}
          visible={confirmPrivateVisble}
          confirmBtnLabel={privateYesLabel}
          onConfirm={handlePrivateConfirmation}
          onCancel={() => setConfirmPrivateVisible(false)}
          data-testid="challenge-details__confirm-private-modal"
        />
        <ConfirmModal
          message={demoMessage}
          visible={confirmDemoVisible}
          confirmBtnLabel={demoYesLabel}
          onConfirm={handleDemoConfirmation}
          onCancel={() => setConfirmDemoVisible(false)}
          data-testid="challenge-details__confirm-demo-modal"
        />
        <ConfirmModal
          message={archiveMessage}
          visible={confirmArchiveVisible}
          confirmBtnLabel={archiveYesLabel}
          onConfirm={handleArchiveConfirmation}
          onCancel={() => setConfirmArchiveVisible(false)}
          data-testid="challenge-details__confirm-archive-modal"
        />
        <ConfirmModal
          message={deleteMessage}
          visible={confirmDeleteVisible}
          confirmBtnLabel={deleteYesLabel}
          onConfirm={handleDeleteChallenge}
          onCancel={() => setConfirmDeleteVisible(false)}
          data-testid="challenge-details__confirm-delete-modal"
        />
        <div style={{ marginTop: '1rem' }}>
          <SpaceBetween size="s">
            {isVisibleOverview() && !isArenaChallenge(challenge) && <ChallengeOverviewDetail />}
            {renderChildView()}
          </SpaceBetween>
        </div>
      </ContentLayout>
    </>
  );
};

export default ChallengeDetails;
